import { Injectable, inject } from "@angular/core";
import { Observable, catchError, throwError } from "rxjs";
import { HttpClient } from "@angular/common/http";
import { CoreAuthConfigService } from "@features/auth/core-auth-config.service";
import { ErrorBase } from "@core/models/error.model";
import { URI_APIs } from "@features/auth/const";
import { VerifyOTPErrorModel } from "../account-first-login/models/verify-otp-code.error";
import { IVerifyOTPCode } from "../account-first-login/models/verify-code-otp.interface";

@Injectable()
export class SSOVerifyOTPCodeService implements IVerifyOTPCode {
  private readonly httpClient = inject(HttpClient);
  private readonly conf = inject(CoreAuthConfigService);

  resendOTPCode(args: any): Observable<any> {
    throw new Error("Method not implemented.");
  }

  confirmOTPCode(code: string, options?: any): Observable<any> {
    const url = this.conf.buildURL(URI_APIs.SSO_VERIFY_FIRST_LOGIN_CONFIRM_OTP);
    return this.httpClient.get(url + code).pipe(
      catchError((err: ErrorBase) => {
        return throwError(() => VerifyOTPErrorModel.handle(err))
      })
    )
  }

}
